import { useEffect, useRef } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { usePmWalletStore } from '@/store/pmWalletStore'

/**
 * После PIN-unlock (pmProxyAddress стал != null) вызывает
 * POST /api/sub/activate-trial один раз на сессию. Сервер idempotent:
 * если users row уже существует, возвращает существующий trialEndsAt.
 */
export function useActivateTrial() {
  const pmProxyAddress = usePmWalletStore((s) => s.pmProxyAddress)
  const activeWallet = usePmWalletStore((s) => s.activeWallet)
  const qc = useQueryClient()
  const sentFor = useRef<string | null>(null)

  useEffect(() => {
    if (activeWallet !== 'pm' || !pmProxyAddress) return
    const addr = pmProxyAddress.toLowerCase()
    if (sentFor.current === addr) return
    sentFor.current = addr

    void (async () => {
      try {
        await fetch('/api/sub/activate-trial', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ address: addr }),
        })
        qc.invalidateQueries({ queryKey: ['subscription', addr] })
      } catch {
        // сервер может быть недоступен в dev — не критично; хук попробует при
        // следующем unlock (если смена адреса)
      }
    })()
  }, [pmProxyAddress, activeWallet, qc])
}
